import React, {useEffect} from 'react';
import { connect } from 'react-redux';
import Background from './hoc/Layout/Background/Background';
import Header from './hoc/Layout/Header/Header';
import Main from './hoc/Layout/Main/Main';

import $ from 'jquery';


import Section from './containers/Section/Section';
import Panels from './containers/Panels/Panels';
import Report from './containers/Report/Report';

import AddMetaTag1 from './components/AddMetaTag1/AddMetaTag1';
import Nav2 from './components/Navigation/Nav2/Nav2';
import Footer from './components/Footer/Footer';
import Gate from './components/Gate/Gate';
import Gate1 from './components/Gate/Gate1';
import Saleschat from './components/Saleschat/Saleschat';
import SrcBox from './components/SrcBox/SrcBox';
import Socials from './components/Socials/Socials';

import QuestionSets from './libs/QuestionSets';

import './App.scss';
import SpiderClass from './components/Spider/SpiderClass';
import { custState, useSkip } from './customHooks/customHooks';
import * as actionCreators from './store/actions/index';

const App = (props) => {
  const search = window.location.search; // could be '?foo=bar'
  const params = new URLSearchParams(search);
  const skip  = params.get('skip');
  const finish = params.get('finish');
  const report = params.get('report');
  const role = params.get('role') && params.get('role').split('_').join(" ");
  let score = params.get('score');
  let gateOff = params.get('gateoff');
  // let srcBox = finish ? null : (<SrcBox/>);
  score = score ? score.split('_').map(scr => Number(scr)) : null;

    //sets cust state to skip if skip
    setCustSkipAndRole(skip, props, role);

  const showGate = gateOff ? null : <Gate/>;

  const retThis = 
    report ? (
      <React.Fragment>
        {showGate}
        <Report
          scrs={score}
          rol={role}
        />
      </React.Fragment>                  
  ) : (
    <React.Fragment>
      <AddMetaTag1/>
      {/* <Saleschat/> */}
      {/* <Gate/> */}
      <Gate1/>
      {/* {srcBox} */}
      <Header />
      <Main>
        <Section
          side={'left'}
        >
          <Panels
          skipped={skip}
            panels={QuestionSets}
          />
        </Section>
        <Section
          side={'right'}
        >
          <SpiderClass
          // levels={3}
          />        
        </Section>
      </Main>
      <Background />
      <Nav2
        // questions={[...QuestionSets['Operations']]}
      />
      {/* <Socials/> */}
      <Footer />
      <Saleschat/>
    </React.Fragment>
  );

  return retThis;
}

export default connect(null, mapDispatchToProps)(App);


function mapDispatchToProps(dispatch){
  return {
    onChangeRole: (role, lang) => dispatch(actionCreators.choose_role(role, lang)),
    onChooseQuestions: (role, lang) => dispatch(actionCreators.choose_questions(role, lang)),
    onResetScores: (r) => dispatch(actionCreators.reset_scores(r)),
    onUpdatePeerScores: (r) => dispatch(actionCreators.update_peerscore(r)),
  };
}

function setCustSkipAndRole(skip, props, role){
  if(skip) {
    custState.skip = skip;
    props.onChangeRole(role);       
    props.onChooseQuestions(role, 'English');
    props.onResetScores(role);
    props.onUpdatePeerScores(role);
  }
}


